import React, { memo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ModalWindow from '@common/components/modal/modal-window';
import ModalContent from '@common/components/modal/modal-content';

type GenerateCourseProps = {
  children: React.ReactNode;
  isCreatingCourse: boolean;
  isGenerateOutline?: boolean;
};

const GenerateCourseModal = memo(
  ({
    children,
    isCreatingCourse,
    isGenerateOutline = false,
  }: GenerateCourseProps) => {
    const [show, setShow] = useState(false);
    const [wasCreatingCourse, setWasCreatingCourse] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
      if (wasCreatingCourse && !isCreatingCourse) {
        setShow(false);
      }
      setWasCreatingCourse(isCreatingCourse);
    }, [isCreatingCourse, wasCreatingCourse]);

    const handleHide = () => {
      setShow(false);
    };

    const handleShow = () => {
      setShow(true);
    };

    return (
      <ModalWindow
        trigger={children}
        show={show}
        onHide={handleHide}
        onShow={handleShow}
        size="small"
        className="GenerateCourse__Modal"
      >
        <ModalContent hideHeader hideFooter>
          <div className="tw-flex tw-flex-col tw-gap-4 tw-p-6">
            <div
              className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center
            tw-border-[1px] tw-border-solid tw-border-gray-border tw-rounded-lg"
            >
              <div
                className="tw-w-5 tw-h-6 tw-rounded tw-bg-no-repeat"
                style={{
                  backgroundImage: `url(${'/static/images/gen-ai-course.png'})`,
                }}
              />
            </div>

            <div className="tw-flex tw-flex-col tw-gap-2">
              <div className="tw-text-lg tw-font-medium tw-font-inter tw-text-gray-textDarkest">
                {isGenerateOutline
                  ? t('learning:generate_outline_modal_title')
                  : t('learning:generate_course_modal_title')}
              </div>
              <div className="tw-text-base tw-text-gray-textDark tw-font-inter tw-font-normal">
                {isGenerateOutline
                  ? t('learning:generate_outline_modal_description')
                  : t('learning:generate_course_modal_description')}
              </div>
            </div>
          </div>
        </ModalContent>
      </ModalWindow>
    );
  }
);

export default GenerateCourseModal;
